import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import MenuItems from "./utils/menuItems/MenuItems";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/esm/Button";
import Row from "react-bootstrap/esm/Row";
import Tiles from "./utils/menuItems/MenuItems";
import gameList from "./utils/GameList";
import { makeGetRequest } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import TimeTracking from "./utils/analytics/TimeTracking";
import { Container } from "react-bootstrap";

function HomePage(props) {
  const [greeting, setGreeting] = useState("Welcome");
  const [today, setToday] = useState({
    temp: "75 °F",
    location: "Wilsonville, Oregon",
  });
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(6);
  const [pageCount, setPageCount] = useState(0);
  const [_lat, _setLat] = useState();
  const [_lon, _setLon] = useState();
  const [weather, setWeather] = useState();
  const [location, setLocation] = useState();
  const [errorDialogBox, setErrorDialogBox] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const nav = useNavigate();
  let todayd = new Date();
  let date =
    parseInt(todayd.getMonth() + 1) +
    "/" +
    todayd.getDate() +
    "/" +
    todayd.getFullYear();

  const page = (num) => {
    if (pageCount === 0 && num === -1) {
      setPageCount(0);
    } else {
      if (pageCount + num > Math.floor(gameList.length / 6) - 1) {
        setPageCount(Math.floor(gameList.length / 6) - 1);
      } else {
        setPageCount((prevCount) => prevCount + num);
      }
    }
  };

/*
  useEffect(() => {
    if ("geolocation" in navigator) {
      console.log("geolocation services are active");
      navigator.geolocation.getCurrentPosition(
        function (position) {
          _setLat(position.coords.latitude);
          _setLon(position.coords.longitude);
        },
        function (error) {
          console.error("Error Code = " + error.code + " - " + error.message);
          if (error.message.includes("User denied Geolocation")) {
            setErrorDialogBox(true);
            setErrorText(
              "To enable your Location look in the address bar of the tablet. You will see a small pin with a red x in it. Click that and set to allow from this website. Then refresh the page."
            );
          }
        }
      );
    } else {
      console.log("geolocation services are not active");
    }
  }, []);

  useEffect(() => {
    if (_lat) {
      getWeatherData();
    }
  }, [_lat]);
  const getWeatherData = async () => {
    const response = await makeGetRequest(
      "https://api.weather.gov/points/" + _lat + "," + _lon,
      null,
      false
    );
    const weatherInArea = await makeGetRequest(
      response.data.properties.forecast,
      null,
      false
    );
    setLocation(response.data.properties.relativeLocation.properties);
    setWeather(weatherInArea.data.properties.periods[0]);
  };*/

  useEffect(() => {
    if (pageCount === 0) {
      setFrom(0);
      setTo(6);
    }
    if (pageCount === 1) {
      setFrom(6);
      setTo(12);
    }
    if (pageCount === 2) {
      setFrom(12);
      setTo(18);
    }
  }, [pageCount]);

  return (
    <>
      <div style={{ padding: "8px" }}>
        <Container>
          <Row style={{ textAlign: "center" }}>
            <Col>
              {/**weather && (
                <h3>
                  {date}
                  <br />
                  {weather.temperature}°{weather.temperatureUnit},{" "}
                  {weather.shortForecast}
                  <br />
                  {location.city}, {location.state}
                </h3>
              )**/}
            </Col>
          </Row>
          <Row
            style={{
              marginTop: "15px",
              height: "100%",
              marginRight:'auto',
              marginLeft:'auto',
            }}
          >
            <Col>
              <Col style={{marginTop:"5px"}}>
                <MenuItems
                  url="/presentation/morning-meeting"
                  fontSize="30px"
                  title="Morning Meeting"
                  fontColor='white'
                  borderC="5px solid white solid"
                />
              </Col>
              <Col style={{marginTop:"5px"}}>
                <MenuItems
                  url="/presentation/afternoon-meeting"
                  fontSize="30px"
                  title="Afternoon Meeting"
                  borderC="5px solid white solid"
                />
              </Col>
              <Col style={{marginTop:"5px"}}>
                <MenuItems url="/exercise" fontSize="30px" title="Exercise" borderC="5px solid white solid"/>
              </Col>
              <Col style={{marginTop:"5px"}}>
                <MenuItems
                  url="/life-long-learning"
                  fontSize="30px"
                  title="Life Long Learning"
                  borderC="5px solid white solid"
                />
              </Col>
              <Col style={{marginTop:"5px"}}>
                <MenuItems
                  url="/bible-study"
                  fontSize="30px"
                  title="Bible Study"
                  borderC="5px solid white solid"
                />
              </Col>
              <Col style={{marginTop:"5px"}}>
                <MenuItems url="/games" fontSize="30px" title="Games" borderC="5px solid white solid"/>
              </Col>
              <Col style={{marginTop:"5px"}}>
                <MenuItems
                  url="/karaoke-resources"
                  fontSize="30px"
                  title="Karaoke"
                  borderC="5px solid white solid"
                />
              </Col>
              <Col style={{marginTop:"5px"}}>
                <MenuItems
                  url="/video-resources"
                  fontSize="30px"
                  title="Videos"
                  borderC="5px solid white solid"
                />
              </Col>
            </Col>
          </Row>
        </Container>
        <Modal show={errorDialogBox} onHide={() => setErrorDialogBox(false)}>
          <Modal.Header closeButton>
            <Modal.Title>An Error has Occurred</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {showError
              ? errorText
              : "Please give your tablet back to your nurse"}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowError(true)}>
              See More..
            </Button>
            <Button variant="primary" onClick={() => setErrorDialogBox(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default HomePage;
